import { useEffect, useState } from 'react';
import { Maintainence } from '../../assets/images';

export default function MaintenanceModal() {
  const [open, setOpen] = useState(false);
  const [etaMinutes, setEtaMinutes] = useState(null);

  useEffect(() => {
    const posthogInstance = window.posthogWebview || window.posthog;

    const checkFeatureEnabled = async () => {
      const isFeatureEnabled =
        await posthogInstance?.isFeatureEnabled('maintenance_banner');
      if (isFeatureEnabled) {
        setOpen(true);
        const payload =
          await posthogInstance?.getFeatureFlagPayload('maintenance_banner');
        if (payload && payload.timestamp) {
          const now = Math.floor(Date.now() / 1000); // current time in seconds
          const diffSeconds = payload.timestamp - now;
          const diffMinutes = Math.max(Math.ceil(diffSeconds / 60), 0);
          setEtaMinutes(diffMinutes);
        }
      }
    };
    checkFeatureEnabled();
  }, []);
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-black/50 z-[1000] px-4 backdrop-blur-sm ${open ? 'block' : 'hidden'} h-screen`}
    >
      <div className='w-full max-w-xs rounded-3xl overflow-hidden bg-gradient-to-br from-blue-100 via-purple-50 to-pink-100 shadow-xl'>
        <div className='relative w-full h-full mb-0'>
          <img
            src={Maintainence}
            alt='Maintainence'
            className='w-full h-full object-cover m-0 p-0'
          />
        </div>
        <div className='p-6 flex flex-col items-center pb-[3.5rem]'>
          <div className='text-center'>
            <div className='flex items-center justify-center mb-2'>
              <span className='text-yellow-400 mr-2 text-xl'>✦</span>
              <h2
                className='text-xl font-bold text-gray-900'
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontSize: '18px',
                  lineHeight: '120%',
                  letterSpacing: '0%',
                  color: '#070519',
                }}
              >
                Maintenance Break
              </h2>
            </div>

            <p
              className='mb-4'
              style={{
                fontFamily: 'Poppins',
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '160%',
                letterSpacing: '0%',
                textAlign: 'center',
                color: '#070519',
              }}
            >
              PadhAI is currently undergoing maintenance. We expect to be back
              online soon. Thank you for your patience!
            </p>

            <div className='text-[#6374FA] font-medium'>
              ETA: {etaMinutes !== null ? `${etaMinutes} mins` : '...'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
